import React from 'react';
import RiskTag from '@gp/pages/StudioDashboard/StudioOverall/components/RiskTag';
import WrapableText from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/components/WrapableText';
// @ts-ignore
import { isEmpty } from '@gp/utils/utils';

import type { TableColumn } from 'tea-component';

const getOpinionStr = (data: IStudioManagementMeetingMajorBody): any => {
  const { tencentOpinionName, conclusionName } = data || {};
  const opinions = [tencentOpinionName, conclusionName];
  const con = opinions.filter((item) => item?.trim()).join(' | ');

  return (
    <span className="dbg-word-break-word" title={con}>
      {con}
    </span>
  );
};

export const getColumns = (): TableColumn<IStudioManagementMeetingMajorBody>[] => [
  {
    key: 'index',
    header: '#',
    width: 50,
    render: (record, rowKey, recordIndex) => recordIndex + 1,
  },
  {
    key: 'resolutionCategoryName',
    header: 'Resolution Category',
    width: 230,
    render: (record) => (
      <WrapableText className="dbg-table-text dbg-word-break-word" text={record?.resolutionCategoryName} />
    ),
  },
  {
    key: 'tencentOpinionNameAndConclusionName',
    header: <>Tencent Opinion | Conclusion</>,
    width: 156,
    render: (record) => getOpinionStr(record) || '-',
  },
  {
    key: 'urgency',
    header: 'Urgency',
    width: 105,
    render: (record) => <RiskTag value={String(record?.urgency)} />,
  },
  {
    key: 'importance',
    header: 'Importance',
    width: 140,
    render: (record) => <RiskTag value={String(record?.importance)} />,
  },
  {
    key: 'content',
    header: 'Resolution Summary',
    render: (record) => <WrapableText className="dbg-word-break-word" text={record?.content} />,
  },
];

export const getValidMajorBodyList = (
  majorBodyList: IStudioManagementMeetingMajorBody[],
): IStudioManagementMeetingMajorBody[] => {
  if (!Array.isArray(majorBodyList)) return [];
  return majorBodyList.filter((majorBody) => {
    const flag1 = isEmpty(majorBody?.resolutionCategoryName);
    const flag2 = isEmpty(getOpinionStr(majorBody));
    const flag3 = isEmpty(majorBody?.urgency) || isEmpty(majorBody?.urgencyName);
    const flag4 = isEmpty(majorBody?.importance) || isEmpty(majorBody?.importanceName);
    const flag5 = isEmpty(majorBody?.content);
    return !(flag1 && flag2 && flag3 && flag4 && flag5);
  });
};
